import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message, Row, Col } from 'antd';
import { graphql, compose } from 'react-apollo';

import MUTATION from '../graphql/mutations/newRetainerClientAssignmentDiscussionTopicMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

class NewRetainerClientAssignmentDiscussionTopicForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, retainerClientAssignmentId } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { retainerClientAssignmentId, ...values } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            message.success('New topic created!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={20}>
          <Col span={12}>
            <FormItem label="Discussion Topic" hasFeedback>
              {getFieldDecorator('title', {
                rules: [{ required: true, message: 'Field is required!' }],
              })(<TextArea disabled={submittingForm} autosize={{ minRows: 1, maxRows: 2 }} />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Description">
              {getFieldDecorator('description')(
                <TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />,
              )}
            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Button type="primary" htmlType="submit" loading={submittingForm}>
            Submit
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewRetainerClientAssignmentDiscussionTopicForm.propTypes = {
  retainerClientAssignmentId: PropTypes.number.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewRetainerClientAssignmentDiscussionTopicForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientAssignmentDiscussionTopicForm.jsx